export default "__VITE_ASSET__81baee42__"